import { Loader } from "@googlemaps/js-api-loader";
import { createContext, useContext, useEffect } from "react";
import usePlacesAutocomplete from "use-places-autocomplete";

export const AutocompleteContext = createContext({});

export const AutocompleteProvider = ({ children }) => {
  const props = usePlacesAutocomplete({
    initOnMount: false,
  });

  const loader = new Loader({
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY,
    version: "weekly",
    libraries: ["places"],
  });

  useEffect(() => {
    loader.importLibrary("places").then(() => props.init());
  }, []);

  return (
    <AutocompleteContext.Provider value={props}>
      {children}
    </AutocompleteContext.Provider>
  );
};

const useAddressAutocomplete = () => {
  const context = useContext(AutocompleteContext);

  if (context === undefined) {
    throw new Error(
      "useAddressAutocomplete must be used within a AutocompleteProvider"
    );
  }
  return context;
};

export default useAddressAutocomplete;
